angular.module('unica_wiki.wiki_controllers', [])

.controller('WikiBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	// $scope.dp_open = false;

	// $scope.openDatepicker = function() {
	// 	$scope.dp_open = true;
	// };

	$scope.changeDateHandler = function () {
		var tmpDate = $rootScope.wikiData.introduction_date;
	};

	$scope.changeWikiAvatar = function() {
		$rootScope.wikiData.image_changed = true;
	};

});